import React, {FC} from "react";
import Form from "react-bootstrap/Form";

interface PropsType {
    id: string;
    value: string;
    handleOnChange: (e: string) => void;
}

export const DisabledStringInput: FC<PropsType> = ({id, value, handleOnChange, ...props}) => {
    return <Form.Control type="text"
                         id={id}
                         placeholder="No default value required."
                         value={value}
                         disabled
                         {...props} />
}
